[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 15,
                "y": 23,
                "key": "_dxA5gfF4F3xa_lALdSHW"
            },
            {
                "x": 15,
                "y": 25,
                "key": "ZMZoq2dGfl4sREnmYetAQ"
            },
            {
                "x": 14,
                "y": 25,
                "key": "EU8eeGQqKqgn8xZEWCtVM"
            },
            {
                "x": 14,
                "y": 26,
                "key": "O_UuoAy9BaNTkUs9VVEuf"
            },
            {
                "x": 12,
                "y": 26,
                "key": "eAgIWORB3zk6Pklj0mpk9"
            },
            {
                "x": 12,
                "y": 27,
                "key": "LGs9ZIyKoNRXQVbHDMPNz"
            },
            {
                "x": 10,
                "y": 27,
                "key": "JX5VNVFOgISz0i1v3m6iv"
            },
            {
                "x": 10,
                "y": 24,
                "key": "EZDW7mDXhSkjQidZzMmOl"
            },
            {
                "x": 12,
                "y": 24,
                "key": "StuvheQdGdk5sSUhSn01R"
            },
            {
                "x": 12,
                "y": 23,
                "key": "xWAmwoWqjm4w6zQ9Ffl8z"
            }
        ]
    },
    {
        "key": "2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 16,
                "y": 20,
                "key": "gHHWEIGjlCtYvdz1Xlto2"
            },
            {
                "x": 21,
                "y": 20,
                "key": "3KXG3hg3g1V5wLrALULjV"
            },
            {
                "x": 21,
                "y": 25,
                "key": "BjEPT9hUy9EmV4IA8yXlT"
            },
            {
                "x": 19,
                "y": 25,
                "key": "LtgRtS8yoUW2cmv4xm0dG"
            },
            {
                "x": 19,
                "y": 27,
                "key": "IXbw0ywd4I1LTWI3yno56"
            },
            {
                "x": 18,
                "y": 27,
                "key": "rluRejEkejok3NiCpqdw0"
            },
            {
                "x": 18,
                "y": 26,
                "key": "vKI78Om8PMNDNlP-ocHZq"
            },
            {
                "x": 17,
                "y": 26,
                "key": "gzHR3wb2UbbGWcRTfJaaA"
            },
            {
                "x": 17,
                "y": 25,
                "key": "Cc_7Daqu2cIJUYanEUBEQ"
            },
            {
                "x": 16,
                "y": 25,
                "key": "bHHY47WVzdQdiJvOoWbJA"
            }
        ]
    },
    {
        "key": "3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 14,
                "y": 13,
                "key": "6hQFBPenOyl7zq8qTsiBn"
            },
            {
                "x": 19,
                "y": 13,
                "key": "eTbU628JtSWvtnkKf5C-g"
            },
            {
                "x": 19,
                "y": 19,
                "key": "kXH6aQkYbws48Fe13pVT7"
            },
            {
                "x": 14,
                "y": 19,
                "key": "TK2SygeZFMuNe6Z7c7wlN"
            }
        ]
    },
    {
        "key": "4",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 20,
                "y": 11,
                "key": "zE6fGgK6ZjncO5IdZ2UhJ"
            },
            {
                "x": 25,
                "y": 11,
                "key": "QvQEGIPh935fDWWCnYRB3"
            },
            {
                "x": 25,
                "y": 16,
                "key": "rKWbVoq4THMw717XdRFTV"
            },
            {
                "x": 20,
                "y": 16,
                "key": "cQB4WQnekyNEdsyg1D1A5"
            }
        ]
    }
]
